@defer (when compliance().current) {
  @if (compliance().current?.assets.length) {
    <main>
      <section class="flex-2">
        <div>
          @if (compliance().previous) {
            <app-compliance-dial [compliance]="compliance().previous" [title]="compliance().previous.title"></app-compliance-dial>
          }
        </div>
        <div>
          @if (compliance().current) {
            <app-compliance-dial [compliance]="compliance().current" [title]="compliance().current.title"></app-compliance-dial>
          }
        </div>
      </section>
      <section>
        <div class="tabview-list">
          <div [class.active]="tabIndex === 0" (click)="tabIndex = 0">{{ compliance().current?.title }}</div>
          <div [class.active]="tabIndex === 1" (click)="tabIndex = 1">{{ compliance().previous?.title }}</div>
          <div></div>
        </div>
        <div class="tabview-content">
          @switch (tabIndex) {
            @case (1) {
              @if (compliance().previous) {
                <div>
                  <app-compliance-assets [compliance]="compliance().previous"></app-compliance-assets>
                </div>
              }
            }
            @default {
              @if (compliance().current) {
                <div>
                  <app-compliance-assets [compliance]="compliance().current"></app-compliance-assets>
                </div>
              }
            }
          }
        </div>
      </section>
    </main>
  } @else {
    <main>
      <app-info-panel icon="info">No compliance data available.</app-info-panel>
    </main>
  }
} @placeholder (minimum 100ms) {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}
